import React from 'react';
import { I18nextProvider } from 'react-i18next';
import az from './locales/az.json';
import ru from './locales/ru.json';
import { configureChatErrorReporter } from '../chat/adapters/errorReporterAdapter';
import { turboSentryErrorReporter } from '../chat-host/adapters/turboSentryErrorReporter';

configureChatErrorReporter(turboSentryErrorReporter);

document.addEventListener('DOMContentLoaded', async () => {
  const container: HTMLElement | null = document.getElementById('chat-write-link');

  if (!container) return;

  container.style.width = '100%';

  try {
    const { createRoot } = await import('react-dom/client');
    const { WriteMessageLink } = await import('./components');
    const { customizeI18n } = await import('../utils/i18n');
    const { ChatNavigationProvider } = await import('../chat/adapters/navigationAdapter');
    const { windowNavigationAdapter } =
      await import('../chat-host/adapters/windowNavigationAdapter');
    const { turboListingAdapter, turboReceiverAdapter } =
      await import('../chat-host/adapters/listingReceiverAdapters');
    const { ThemeProviderWrapper } =
      await import('@/styled/themes/ThemeProvider/ThemeProviderWrapper');
    const { TurboAuthAdapterProvider } =
      await import('../chat-host/adapters/TurboAuthAdapterProvider');

    const isUserSignedIn = container.dataset.userSignedIn === 'true';
    const isMobile = container.dataset.isMobile === 'true';
    const listing = turboListingAdapter(JSON.parse(container.dataset.listing || ''));
    const receiver = turboReceiverAdapter(JSON.parse(container.dataset.receiver || ''));

    const i18n = customizeI18n({ az, ru });

    createRoot(container).render(
      <ChatNavigationProvider
        adapter={windowNavigationAdapter}
        currentPath={windowNavigationAdapter.getCurrentPath()}
      >
        <TurboAuthAdapterProvider isSignedIn={isUserSignedIn}>
          <I18nextProvider {...{ i18n }}>
            <ThemeProviderWrapper>
              <WriteMessageLink
                {...{ isUserSignedIn, listing, receiver, isMobile }}
                backgroundColor="#4c88f9"
              />
            </ThemeProviderWrapper>
          </I18nextProvider>
        </TurboAuthAdapterProvider>
      </ChatNavigationProvider>
    );
  } catch (e) {
    console.error('Failed while initializing chat-write-link', e);
  }
});
